/**
 * Origem Flow: serviço do hub de Quadros brancos (/api/whiteboards/*).
 */
export default (client) => {
  return {
    fetchAll(workspaceId, { tableId = null, rowId = null } = {}) {
      const params = {}
      if (tableId) {
        params.table_id = tableId
      }
      if (rowId) {
        params.row_id = rowId
      }
      return client.get(`/whiteboards/workspace/${workspaceId}/`, { params })
    },
    create(workspaceId, { name = '' } = {}) {
      return client.post(`/whiteboards/workspace/${workspaceId}/`, { name })
    },
    get(whiteboardId) {
      return client.get(`/whiteboards/${whiteboardId}/`)
    },
    update(whiteboardId, values) {
      return client.patch(`/whiteboards/${whiteboardId}/`, values)
    },
    delete(whiteboardId) {
      return client.delete(`/whiteboards/${whiteboardId}/`)
    },
  }
}
